import { createContext, useState, useEffect } from 'react';
import { adminService } from '../services/api';
import { useNavigate } from 'react-router-dom';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if token exists on load
    const token = localStorage.getItem('adminToken');
    const adminEmail = localStorage.getItem('adminEmail');
    if (token && adminEmail === 'envdock@gmail.com') {
      setUser({ email: adminEmail });
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    if (email !== 'envdock@gmail.com') throw new Error("Unauthorized email.");

    const { data } = await adminService.login(email, password);
    localStorage.setItem('adminToken', data.token);
    localStorage.setItem('adminEmail', data.email);
    setUser(data.user);
    return data
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminEmail');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ setUser, user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};